import BaseApi from "../../BaseApi";

export default class Indicators extends BaseApi {

    static getApiUrl() {
        return BaseApi.getApiVersionBasePath("v1")
            + "assessment-models/indicators";
    }

    static async indicators(type, id, locale = null, filters = {}) {
        const path = [
            this.getApiUrl(),
            type,
            id,
            locale,
        ]
            .filter(Boolean)
            .join("/");

        return this.get(path, {
            params: filters,
        });
    }

    static async create(type, payload) {
        return this.post(`${this.getApiUrl()}/${type}`, payload);
    }

    static async update(type, id, payload) {
        return this.patch(`${this.getApiUrl()}/${type}/${id}`, payload);
    }

    static async delete(type, id, payload = {}) {
        return this.getAxiosInstance().delete(`${this.getApiUrl()}/${type}`, {data: payload});
    }
}
